// extracted by mini-css-extract-plugin
export default {"Iframe":"ScratchGames_Iframe__2qeI-","backContainer":"ScratchGames_backContainer__CiEIO"};